import { useContext } from 'react';

import { HeaderExternalElementContext } from '@neptune/project-domain';

export const useHeaderExternalElement = (): HTMLElement | null => {
  const context = useContext(HeaderExternalElementContext);

  if (context === null) {
    throw new Error(
      'useHeaderExternalElement must be used within a HeaderExternalElementContextProvider',
    );
  }

  return context;
};
